import { redirect } from "@tanstack/react-router";

import { isConfigurator } from "@/lib/auth";

// Reusable `beforeLoad` guard for configurator-only surfaces (e.g. `/admin/*`): redirect a
// non-configurator away. This is presentation/UX defense-in-depth — **not** the security boundary.
// The real gate is server-side (the agent `/kb/*` reads the admin surface consumes require auth;
// see docs/spec/concepts.md). Apply as `beforeLoad: () => requireConfigurator()`.
export function requireConfigurator(): void {
  if (!isConfigurator()) {
    throw redirect({ to: "/" });
  }
}
